import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBg2NZQho1X74JxjJO3No8Ki1_mNVMal3Q",
  authDomain: "mogul-rent.firebaseapp.com",
  databaseURL: "https://mogul-rent-default-rtdb.firebaseio.com",
  projectId: "mogul-rent",
  storageBucket: "mogul-rent.firebasestorage.app",
  messagingSenderId: "1079945138351",
  appId: "1:1079945138351:web:a410ea64464a01de10445a",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
